import { updateKeyInStore } from 'App';
import { ProfitAndLossStatementStateValues, updateKey } from '../slice';

export const uploadFields:
  | IBaseField<keyof ProfitAndLossStatementStateValues>
  | {}[] = [
  {
    name: 'pleaseUploadYourProfitAndLossStatements',
    label: 'Please upload your profit and loss statements.',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    predicate: (v: any) => v == 'yes',
    dependentOn:
      'taxQuestionnaire.additionalQuestions.profitandLossStatement.values.doYouHaveAProfitAndLossStatementPreparedForYear',
  },
];
